import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';
import { SearchComponent } from './search/search.component';
import { AddComponent } from './add/add.component';

import { AppointmentComponent } from './appointment.component';
import { AppointmentsRoutingModule } from './appointments-routing.module'
import { CRUDTableModule } from '../../_Core/shared/crud-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { SatPopoverModule } from '@ncstate/sat-popover';
import { CoreModule } from '../../_Core/core';
import { MatRippleModule,MatNativeDateModule,} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import {TranslationModule} from '../i18n/translation.module';
import { CdkTableModule } from '@angular/cdk/table';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { ObserversModule } from '@angular/cdk/observers';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { AppointmentSpecialtiesComponent } from './specialties/specialties.component';
import { AppointmentsDoctorComponent } from './doctor/doctor.component';
import { SafeImgUrlPipe } from './safeImgUrl.pipe';
import { ConfirmationModalComponent } from './search/confirmation-modal/confirmation-modal.component';
import { ConfirmSaveModalComponent } from './add/confirm-save-modal/confirm-save-modal.component';
import { AnotherServiceComponent } from './another-service/another-service.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [
      SearchComponent,
      AppointmentComponent,
      AddComponent,
      AppointmentSpecialtiesComponent,
      SafeImgUrlPipe,
      AppointmentsDoctorComponent,
      ConfirmationModalComponent,
      ConfirmSaveModalComponent,
      AnotherServiceComponent
    ],
    imports: [
        NgxSpinnerModule,
        TranslationModule,
        CommonModule,
        HttpClientModule,
        AppointmentsRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        InlineSVGModule,
        CRUDTableModule,
        NgbModalModule,
        NgbDatepickerModule,
        MatDatepickerModule,
        MatIconModule,
        MatNativeDateModule,
        MatSidenavModule,
        MatGridListModule,
        MatToolbarModule,
        MatBottomSheetModule,
        MatExpansionModule,
        MatDividerModule,
        MatSortModule,
        MatStepperModule,
        MatRippleModule,
        CoreModule,
        MatTreeModule,
        MatButtonToggleModule,
        SatPopoverModule,
        CdkTableModule,
        A11yModule,
        BidiModule,
        ObserversModule,
        OverlayModule,
        PlatformModule,
        PortalModule,
        NgSelectModule
    ],
    exports:[AddComponent]
})
export class AppointmentsModule {}
